import { gql } from '@eti/schema-types';

export const FAQ = gql(/* GraphQL */ `
  query getFaqSections {
    faq(faqType: MY_PORTAL) {
      sections {
        questionAndAnswers {
          answer
          question
          slug
        }
        slug
        title
      }
    }
  }
`);

export const ANCILLARY_AVAILABILITY = gql(/* GraphQL */ `
  query getAncillaryAvailability {
    ancillaryAvailabilityForOrder {
      trips {
        availableExtraProducts {
          code
          id
          name
          texts {
            salesAbstract
            smallCardText
          }
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                departureAirport
                departureDateTime
                flightNumber
                available
                boundType
                boundIndex
              }
            }
          }
          sellSpecification {
            ... on SellSpecificationSeatingSeatMapNew {
              __typename
              sellSeatMapBounds {
                id
                sellSeatMapSegments {
                  ... on SellSeatMapSegmentNew {
                    __typename
                    id
                    travelerIds
                    bestPriceCharacteristics {
                      characteristic
                      price
                    }
                    lowerDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    mainDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                    upperDeck {
                      cabins {
                        rows {
                          characteristics
                          rowNumber
                          sellSeatMapSeats {
                            column
                            isBookable
                            price {
                              price {
                                value
                              }
                              markup {
                                value
                              }
                            }
                            row
                            seat
                            type
                            mainCharacteristic
                          }
                        }
                        sellSeatMapColumnDetails {
                          columnName
                          type
                        }
                      }
                    }
                  }
                  ... on SellSeatingPreference {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                  ... on SellSeatingBeside {
                    __typename
                    price {
                      price {
                        value
                      }
                      markup {
                        value
                      }
                    }
                    id
                  }
                }
              }
            }
            ... on SellSpecificationBaggageNew {
              sellPriceBaggage {
                maxWeight
                numberOfUnits
                travelerId
                weightUnit
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on SellSpecificationTravelerNew {
              sellPriceTravelers {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on SellCabinBaggageNew {
              weight
              weightUnit
              pieces
              size3d {
                height
                length
                width
              }
              sellPriceTravelers {
                travelerId
                price {
                  price {
                    value
                    currency {
                      code
                    }
                  }
                  markup {
                    value
                    currency {
                      code
                    }
                  }
                  vat {
                    currency {
                      code
                    }
                    value
                  }
                }
              }
            }
            ... on SellSpecificationTravelerChoiceNew {
              availableChoices {
                id
                name
                descriptions {
                  text
                  type
                }
                pricePerTravelers {
                  price {
                    price {
                      value
                    }
                  }
                  travelerId
                }
              }
              preselectedChoice
              pricePerTravelers {
                price {
                  price {
                    value
                  }
                }
                travelerId
              }
            }
            ... on SellSpecificationNoneNew {
              price {
                price {
                  value
                }
              }
            }
          }
          configuration {
            postbookingAncillaryStore {
              persuasionEnabled
              showPricePerBound
              showPricePerTraveler
              highlightProduct
            }
            productPreSelection
          }
        }
      }
    }
  }
`);

export const CANCELLATION_OPTIONS = gql(/* GraphQL */ `
  mutation getCancellationOptions {
    cancellationOptions {
      refundOffers {
        refundOfferReason
        refundableAmount
        refundOfferId
        nonRefundableProducts {
          amount
          code
          name
          productSummaryAlternativeName
        }
        airlineFee
        handlingFee
        expirationDateTimeUTC
        totalAmountForNonRefundableProducts
        refundableAmountInChargingCurrency {
          currency {
            name
            exponent
            code
          }
          value
        }
      }
      refundOffersError
      includedCancellationProducts {
        id
        name
        code
        texts {
          legalInformation
          upsellTextWhenBooked
        }
      }
    }
  }
`);

export const ORDER_QUERY = gql(/* GraphQL */ `
  query getOrderOnOrderDetailsPage {
    orderNew {
      isEligibleForCancellationCertificate
      shouldAddInstallmentFeeInTotalAmount
      serviceFee {
        value
      }
      addOnOrders {
        price {
          price {
            value
          }
        }
        customerOrderReference
        creationDate
        extraProducts {
          code
          id
          name
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                departureAirport
                departureDateTime
                flightNumber
                available
                boundType
                boundIndex
              }
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                maxWeight
                weightUnit
                pieces
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerCabinBaggage {
              __typename
              travelerCabinBaggagePrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                travelerId
                choice
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
              travelerSeatMapPrices {
                travelerId
                boundIndex
                segmentIndex
                seat
                price {
                  price {
                    value
                  }
                }
              }
            }
          }
          price {
            price {
              value
            }
          }
          texts {
            legalInformation
            upsellTextWhenBooked
            agentNotes
          }
        }
        orderNumber
      }
      customerDetails {
        email
        name
        phone
      }
      flightInformation {
        segments {
          arrivedAt
          departuredAt
          destination
          destinationCityCode
          origin
          originCityCode
        }
        carrier {
          code
          name
        }
        loginEmail
        pnr
        url
        isEligibleForScheduleChangeRefund
        externalFlightVerificationInfo {
          isExternalFlightVerified
          locale {
            countryCode
            languageCode
          }
          suppliers {
            lccSupplier
            carrierCodes
          }
        }
      }
      partOfExternalFlights
      chargeCurrencyPriceFormat {
        currencySymbol
        currencyName
        decimalSymbol
        currencyExponent
        groupingSeparator
        pattern
      }
      discountPrice {
        price {
          value
        }
      }
      instalmentsTotalFee
      isUpsellAllowed
      orderNumber
      oldOrderNumber
      orderReferenceSerialized
      orderState
      cancelReason
      paymentProducts {
        productSummaryAlternativeName
        price {
          price {
            value
          }
        }
        name
        type
        cardSubType
        maskedCardNumber
      }
      postBookingLink
      purchaseDate
      totalPrice
      totalPriceIncludingAddOnOrders
      totalPriceIncludingAddOnOrdersInChargeCurrency
      transactionBreakdown {
        carrierName
        transactionAmount {
          price {
            currency {
              code
              name
              exponent
            }
            value
          }
        }
      }
      trips {
        ancillaryBundles {
          id
          name
          selectedOption
          options {
            id
            name
            content {
              code
              productTypeId
              name
              included
              upsellTextWhenBooked
              legalInformation
            }
            price {
              price {
                value
              }
            }
          }
        }
        isVI
        type
        travelers {
          id
          name
          ageType
          frequentFlyerCard {
            cardType
            cardTypeName
            number
          }
          firstName
          lastName
          fullName
          gender
        }
        travelerPrices {
          carrierPriceBreakdowns {
            carrier {
              code
              name
            }
            providerPrice {
              value
            }
            vat {
              value
            }
          }
          price {
            price {
              value
            }
            vat {
              value
            }
            markup {
              value
            }
          }
          taxesAndFees {
            category
            taxes {
              code
              title
              amount {
                value
              }
            }
          }
          travelerId
        }
        tripId: id
        bounds {
          boundId: id
          includedCheckedBaggage {
            ...IncludedCheckedBaggage
          }
          originalVersion {
            originalSegments {
              arrivedAt
              departuredAt
            }
          }
          segments {
            ... on TripSegment {
              __typename
              arrivedAt
              brandedFareInformation {
                name
              }
              cabinClassName
              carrierBookingNumber {
                bookingNumber
                carrierCode
                carrierName
              }
              departuredAt
              duration
              destination {
                code
                name
                cityCode
                cityName
              }
              eTickets {
                ticketNumber
                travelerId
              }
              equipmentCode
              flightNumber
              segmentId: id
              includedCheckedBaggage {
                ...IncludedCheckedBaggage
              }
              marketingCarrier {
                code
                name
              }
              numberOfTechnicalStops
              technicalStops {
                arrivalAt
                departureAt
                duration
                location {
                  code
                  name
                  cityName
                  cityCode
                }
              }
              operatingCarrier {
                code
                name
              }
              origin {
                code
                name
                cityCode
                cityName
              }
              pnr
              lccSupplier
              virtualCard {
                cvc
                expMonthYear
                lastFourDigits
              }
            }
            ... on EventSegment {
              __typename
              types
              duration
              segmentId: id
            }
          }
        }
        checkedBaggageSummary {
          tripSummaries {
            travelerId
            baggageDetails {
              pieces
              weight
              weightUnit
            }
            baggageStatus
          }
          boundSummaries {
            boundId
            summaries {
              baggageDetails {
                pieces
                weight
                weightUnit
              }
              baggageStatus
              travelerId
            }
          }
        }
        cabinBaggageTripSummary {
          cabinBaggageTravelerDetails {
            cabinBaggageStatus
            travelerId
            cabinBaggageDetails {
              pieces
              size3d {
                height
                length
                width
              }
              weight
              weightUnit
            }
          }
          cabinBaggageBoundSummaries {
            boundId
            cabinBaggageTravelerDetails {
              cabinBaggageDetails {
                pieces
                size3d {
                  height
                  length
                  width
                }
                weight
                weightUnit
              }
              cabinBaggageStatus
              travelerId
            }
          }
        }
        secondBagTripSummary {
          secondBagSummaries {
            baggageDetails {
              pieces
              weight
              weightUnit
            }
            travelerId
          }
        }
        personalItemTripSummary {
          personalItemTravelerDetails {
            personalItemStatus
            travelerId
            personalItemDetails {
              size3d {
                height
                length
                width
              }
            }
          }
          personalItemBoundSummaries {
            boundId
            personalItemTravelerDetails {
              personalItemStatus
              travelerId
            }
          }
        }
        extraProducts {
          id
          name
          productSpecificTexts {
            ... on ProductSegmentAvailabilityTexts {
              __typename
              productSegmentAvailabilityTexts {
                loungeInfo {
                  closeAt
                  loungeName
                  openAt
                  terminal
                  amenities {
                    code
                    id
                    name
                  }
                  conditions {
                    code
                    description
                  }
                }
                arrivalAirport
                departureAirport
                departureDateTime
                flightNumber
                available
                boundType
                boundIndex
              }
            }
          }
          ancillaryCarrierPriceBreakdowns {
            carrier {
              code
              name
            }
            providerPrice {
              value
            }
          }
          productSummaryAlternativeName
          code
          tripId
          price {
            price {
              value
            }
            markup {
              value
            }
          }
          buySpecification {
            ... on BuySpecificationCartTraveler {
              __typename
              travelerPrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerBaggage {
              __typename
              travelerBaggageTripPrices {
                travelerId
                maxWeight
                weightUnit
                pieces
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerCabinBaggage {
              __typename
              travelerCabinBaggagePrices {
                travelerId
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerChoice {
              __typename
              travelerChoicePrices {
                travelerId
                choice
                price {
                  price {
                    value
                  }
                }
              }
            }
            ... on BuySpecificationCartTravelerSeatMap {
              __typename
              travelerSeatMapPrices {
                travelerId
                boundIndex
                segmentIndex
                seat
                price {
                  price {
                    value
                  }
                }
              }
            }
          }
          texts {
            legalInformation
            upsellTextWhenBooked
          }
        }
        tripCharacteristics
        fareRules {
          header
          content
        }
      }
      travelDocLink
      refundStatus {
        cases {
          cancelReason
          providerBookings {
            ... on RefundCaseProviderBooking {
              reference
              providerBookingResult
              carrier
              carrierCode
              cc2Carrier
              hasAcceptedVoucher
              lastUpdatedUTC
              steps {
                step
                completed
              }
              payoutDelayed
              bounds {
                destination
                destinationCityCode
                origin
                originCityCode
              }
              journeyType
            }
            ... on RefundCaseRelatedProviderBooking {
              reference
              lastUpdatedUTC
            }
          }
          refundPayouts {
            manuallyCalculatedRefundAmount {
              currency {
                code
                exponent
                name
              }
              value
            }
            refundHandlingFee {
              currency {
                code
                exponent
                name
              }
              value
            }
            refundNonBankAddition {
              currency {
                code
                exponent
                name
              }
              value
            }
            refundPaymentMethod {
              maskedCardNumber
              paymentSubType
              paymentType
            }
            refundedProducts {
              code
              name
              refundedAmount {
                currency {
                  code
                  exponent
                  name
                }
                value
              }
            }
            refundedProductsTotalAmount {
              currency {
                code
                exponent
                name
              }
              value
            }
            refundedProviderBookings {
              bounds {
                destination
                origin
              }
              journeyType
              reference
              refundedAmount {
                currency {
                  code
                  exponent
                  name
                }
                value
              }
            }
            totalRefundedAmount {
              currency {
                code
                exponent
                name
              }
              value
            }
          }
        }
        refundedCasesTotalAmount {
          currency {
            code
            exponent
            name
          }
          value
        }
        hasChargeback
      }
    }
  }
`);

export const REBOOK_ELIGIBILITY = gql(/* GraphQL */ `
  mutation rebookEligibility {
    rebookEligibility {
      rebookFlow
      message
    }
  }
`);

export const CHECKIN_STATUS_QUERY = gql(/* GraphQL */ `
  query getCheckInStatus {
    checkInStatus {
      legs {
        arrivalAirport
        departureAirport
        arrivalCity
        departureCity
        departureDate
        departureTime
        passengerLegs {
          passengerId
          status
        }
      }
      errorCode
      passengers {
        firstName
        lastName
        passengerId
      }
    }
  }
`);

export const TRAVEL_DOCS_INFO = gql(/* GraphQL */ `
  query getTravelDocsInfo {
    travelDocsInfo {
      apisInfo {
        description
        title
      }
      carrierInfo {
        carrier {
          code
          name
        }
        description
        title
      }
      visaInfo {
        country {
          code
          name
        }
        description
        title
      }
    }
  }
`);
